var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import { Trans, withTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { getCookie, setCookie } from '../core/utils/cookie';
import { localizeUrl } from '../core/helpers/url-helper';
var CookieConsent = /** @class */ (function (_super) {
    __extends(CookieConsent, _super);
    function CookieConsent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isVisible: false,
        };
        return _this;
    }
    CookieConsent.prototype.componentDidMount = function () {
        if (!getCookie('cookie_consent')) {
            this.setState({ isVisible: true });
        }
    };
    CookieConsent.prototype.render = function () {
        var _this = this;
        if (!this.state.isVisible) {
            return null;
        }
        return (React.createElement("div", { className: "c-cookie-consent" },
            React.createElement("div", { className: "c-cookie-consent__content" },
                React.createElement("div", { className: "c-cookie-consent__message" },
                    React.createElement("i", { className: "icon-cookie" }),
                    React.createElement("p", { className: "c-cookie-consent__text" },
                        React.createElement(Trans, { i18nKey: "cookie_consent.message" },
                            React.createElement(Link, { to: localizeUrl(this.props.t('route.cookie_policy.slug')) }, "Cookie Policy")))),
                React.createElement("div", { className: "c-cookie-consent__footer" },
                    React.createElement("button", { className: "c-cookie-consent__button", onClick: function () { return _this.handleClick(); } }, this.props.t('cookie_consent.button'))))));
    };
    CookieConsent.prototype.handleClick = function () {
        setCookie('cookie_consent', 'true');
        this.setState({ isVisible: false });
    };
    return CookieConsent;
}(React.Component));
export default withTranslation()(CookieConsent);
